import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './product.css';

function ProductCatalog() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/products`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProducts(res.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load products');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) return <div className="product-page">Loading products...</div>;
  if (error) return <div className="product-page error-message">{error}</div>;

  return (
    <div className="product-page">
      <h2>Product Catalog</h2>
      {products.length === 0 ? (
        <div className="empty-state">No products found.</div>
      ) : (
        <div className="product-grid">
          {products.map((product) => (
            <div key={product._id} className="product-card">
              <div className="product-header">
                <h3>{product.title}</h3>
                <span className={`status ${product.isPublished ? 'published' : 'draft'}`}>
                  {product.isPublished ? 'Published' : 'Draft'}
                </span>
              </div>
              <p>{product.description}</p>
              <div className="product-details-row">
                <span>Price: ₹{product.price}</span>
                <span>Stock: {product.stock}</span>
              </div>
              <div className="product-details-row">
                <span>Category: {product.category || 'N/A'}</span>
                <span>Vendor: {product.vendor?.name || 'Unknown'}</span>
              </div>
              {product.imageUrl && (
                <img src={product.imageUrl} alt={product.title} className="product-image" />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProductCatalog;
